import React, { useEffect, useState } from "react";
import logo from "../../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "../../utility/SidebarMenuItem/MenuItem";
import { getUserRoleFromToken } from "../../utility/authUtils";

const Sidebar = () => {
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const role = getUserRoleFromToken();
    setUserRole(role);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="w-72 px-5 py-3 mx-3 my-3 rounded-lg shadow-lg">
        Loading...
      </div>
    );
  }

  // Filter menu items based on user role
  const filteredMenuItems = menuItems.filter((item) => {
    if (!item.roles) return true;
    if (!userRole) return false;
    return item.roles
      .map((r) => r.toLowerCase())
      .includes(userRole.toLowerCase());
  });

  if (filteredMenuItems.length === 0) {
    return (
      <div className="w-72 px-5 py-3 mx-3 my-3 rounded-lg shadow-lg">
        <div className="flex justify-center">
          <img src={logo} alt="logo" className="h-16" />
        </div>
        <div className="text-center mt-4 text-red-500">
          No menu items available for your role.
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="w-72 px-5 py-3 mx-3 my-3 rounded-lg shadow-lg overflow-y-scroll scrollbar-hide">
        <div>
          <div className="flex justify-center">
            <img src={logo} alt="logo" className="h-16" />
          </div>
        </div>
        <div className="border-t border-gray-400 mt-2">
          {filteredMenuItems.map((item, index) => (
            <div key={index} className="block">
              <div className="flex items-center justify-between gap-2 px-1 w-full cursor-pointer">
                <Link
                  to={item.path}
                  className={`flex items-center gap-4 w-full group hover:bg-white transition-all duration-500 py-2 mt-2 px-4 rounded-lg ${
                    location.pathname === item.path
                      ? "bg-white text-primary shadow-xl"
                      : ""
                  }`}
                >
                  <span
                    className={`p-2 rounded-lg shadow-lg text-primary transition-all duration-500 ${
                      location.pathname === item.path
                        ? "bg-primary text-white "
                        : "bg-white group-hover:bg-primary group-hover:text-white"
                    }`}
                  >
                    {item.icon}
                  </span>
                  <p
                    className={`text-sm font-medium ${
                      location.pathname === item.path
                        ? "text-primary"
                        : "text-primary"
                    }`}
                  >
                    {item.label}
                  </p>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
